import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GlobalProvider } from './context/GlobalContext';
import { HomeworkProvider } from './context/HomeworkContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GlobalProvider>
            <HomeworkProvider>
                <App />
            </HomeworkProvider>
        </GlobalProvider>
    </React.StrictMode>,
);
